import { Select } from "antd";
import { RootState } from "app.store";
import * as React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LanguageIcons } from "./icons";

export interface ILanguageSelectorProps {
  selectedCode?: string;
  onChange: (value: string) => Promise<void>;
  onClick?: (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  width?: number;
}

export function LanguageSelector(props: ILanguageSelectorProps) {
  const { width, selectedCode, onChange,onClick } = props;
  const clientLanguages = useSelector(
    (state: RootState) => state.localization.clientLanguages,
    shallowEqual
  );
  return (
    <Select style={{width: width}} value={selectedCode} onChange={onChange} onClick={onClick}>
      {clientLanguages.map((language) => (
        <Select.Option key={language.langCode}>
          {LanguageIcons[language.langCode]} {language.name}
        </Select.Option>
      ))}
    </Select>
  );
}
